<template>
<div>
    <h3 class="d-flex justify-content-center">Registro del usuario</h3>
    <div class="d-flex justify-content-center">

        <div class="card" style="width: 48rem;" v-loading="loading" element-loading-text="Cargando..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
            <div class="card-body">
                <form @submit.prevent="submit" id="upload" enctype="multipart/form-data" method="post">
                    <div class="row">
                        <div class="col-lg-12">

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Nombres completos</label>
                                    <el-input v-model="form.name" placeholder="Jose Enrique Alfaro Leon" clearable />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Correo</label>
                                    <el-input type="email" v-model="form.email" placeholder="ejemplo@gmail.com" clearable />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Contraseña</label>
                                    <el-input v-model="form.password" placeholder="password" show-password />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Confirmar contraseña</label>
                                    <el-input v-model="form.passwordValidate" placeholder="password" show-password />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Teléfono</label>
                                    <el-input v-model="form.phone" placeholder="teléfono" />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Tipo de documento</label>
                                    <br>
                                    <select v-model="form.type_doc" id="item">
                                        <option value="0" disabled selected>Seleccione una acción</option>
                                        <option v-for="item in this.documents" :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Nro. de documento</label>
                                    <el-input v-model="form.number_doc" placeholder="Número de documento" />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Curso</label>
                                    <br>
                                    <select v-model="this.form.producto_id" id="item2">
                                        <option value="0" disabled selected>Seleccione una acción</option>
                                        <option v-for="item in this.products" :value="item.id">{{item.nombre}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Pago fraccionado?</label>
                                    <el-checkbox v-model="this.pagoFraccionado" label="si" size="large" />
                                </div>
                            </div>

                            <div v-if="this.pagoFraccionado == true" class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Fecha del pago</label>
                                    <br>
                                    <el-date-picker v-model="form.fecha_pago" type="date" placeholder="Selecciona un dia" size="default" format="YYYY/MM/DD" value-format="YYYY-MM-DD" />
                                </div>
                            </div>

                            <div class="col-lg-12 justify-content-center">
                                <div class="form-group">

                                    <label>Monto</label>
                                    <el-input v-model="form.amount" placeholder="teléfono" />
                                </div>
                            </div>

                        </div>
                    </div>
                    <br>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-success" :disabled="isSubmitting">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        documents: Array,
        products: Array,
    },

    data() {
        return {
            loading: false,
            extensions: '.jpeg, .jpg, .png',
            categories: [],
            form: {},

            fileList: [],
            isSubmitting: false,
            pagoFraccionado: false,
        };
    },
    created() {
        this.initForm();
    },
    methods: {

        redireccionar() {
            window.location.href = this.route;
        },

        handleExceed(file) {
            const isLt1M = file.size > 100000;

            if (!isLt1M) {
                this.$message.error('El archivo no debe pesar más de 100kb!');
                this.$refs.courseUpload.clearFiles();
                return false;
            }
        },
        onUploadChange(file) {
            this.fileList = [];

            const isImage =
                file.raw.type === 'image/jpeg' ||
                file.raw.type === 'image/png' ||
                file.raw.type === 'image/jpg';

            // 100kb
            const isLt1M = file.size < 100000;

            if (!isImage) {
                this.$message.error('Solo puede cargar archivos en formato jpg|jpeg|png.');
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            if (!isLt1M) {
                this.$message.error('El archivo no debe pesar más de 100kb!');
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            this.fileList.push(file);
        },

        handleLevelChange(value) {
            if (value == 1) {
                this.form.price = '0';
            }
        },
        initForm() {
            this.form = {
                name: null,
                email: null,
                password: null,
                passwordValidate: null,
                phone: null,
                passwordValidate: null,
                type_doc: '0',
                number_doc: null,
                producto_id: '0',
                fecha_pago: null,
                amount: null,

            };
        },
        hasEspecialCharacters(text) {
            // Solo puede contener vocales con tilde A-Z  y 0-9
            const regex = new RegExp(/^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g);
            return regex.test(text);
        },
        validateFields() {
            if (!this.form.name || this.form.name.trim() === '' || this.form.name.length === 0) {
                this.$message.warning('Nombre esta vacío!');
                return false;
            }

            if (this.form.name.length > 60) {
                this.$message.warning('Nombre demasiado largo!');
                return false;
            }

            if (!this.form.email || this.form.email.trim() === '' || this.form.email.length === 0) {
                this.$message.warning('Email esta vacío!');
                return false;
            }

            if (this.form.email.length > 60) {
                this.$message.warning('Email demasiado largo!');
                return false;
            }

            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) {
                this.$message.warning('Email incorrecto!');
                return false;
            }

            if (!this.form.password || this.form.password.trim() === '' || this.form.password.length === 0) {
                this.$message.warning('Contraseña esta vacía!');
                return false;
            }

            if (this.form.password.length > 60) {
                this.$message.warning('Contraseña demasiado larga!');
                return false;
            }

            if (!this.form.passwordValidate || this.form.passwordValidate.trim() === '' || this.form.passwordValidate.length === 0) {
                this.$message.warning('Confirmar contraseña esta vacía!');
                return false;
            }

            if (this.form.password !== this.form.passwordValidate) {
                this.$message.warning('Las contraseñas no coinciden');
                return false;
            }

            if (!this.form.phone || this.form.phone.trim() === '' || this.form.phone.length === 0) {
                this.$message.warning('Teléfono esta vacío!');
                return false;
            }

            if (this.form.phone.length > 60) {
                this.$message.warning('Nombre demasiado largo!');
                return false;
            }

            if (this.form.type_doc == 0) {
                this.$message.warning('Seleccione un tipo de documento!');
                return false;
            }

            if (!this.form.number_doc || this.form.number_doc.trim() === '' || this.form.number_doc === 0) {
                this.$message.warning('Número de documento esta vacio!');
                return false;
            }

            if (this.form.number_doc.length > 50) {
                this.$message.warning('Número de documento es demasiado largo!');
                return false;
            }

            if (this.form.producto_id == 0) {
                this.$message.warning('Seleccione un curso!');
                return false;
            }

            if (!this.form.amount || this.form.amount.trim() === '' || this.form.amount === 0) {
                this.$message.warning('Número de documento esta vacio!');
                return false;
            }

            if (this.form.amount.length > 50) {
                this.$message.warning('Monto es demasiado largo!');
                return false;
            }

            return true;
        },

        async submit() {
            if (this.validateFields()) {
                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append('name', this.form.name);
                formdata.append('email', this.form.email);
                formdata.append('password', this.form.password);
                formdata.append('phone', this.form.phone);
                formdata.append('type_doc', this.form.type_doc);
                formdata.append('number_doc', this.form.number_doc);
                formdata.append('producto_id', this.form.producto_id);

                if (this.pagoFraccionado == true) {
                    formdata.append('is_fractioned', 'on');
                    formdata.append('fecha_pago', this.form.fecha_pago);
                }

                formdata.append('amount', this.form.amount);

                try {
                    this.loading = true;
                    const request = await axios({
                        url: 'registrar/admin',
                        method: 'post',
                        data: formdata,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    });
                    const response =
                        request.status == 200 ?
                        this.$message.success('El usuario ha sido registrado correctamente') :
                        await this.$message.warning('Error al validar datos');
                    this.isSubmitting = false;
                    this.loading = false;
                    this.initForm();
                    this.fileList = [];
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    console.log(error);
                }
            }
        },
    },
};
</script>
